import { auth, getFreshToken } from 'providers/firebaseAuth'
import { captureError } from 'utils/error'

export const REAUTH_OUTCOME = {
  REFRESHED: 'refreshed',
  SESSION_OVER: 'session-over',
  UNAVAILABLE: 'unavailable',
} as const

type ReauthOutcome = typeof REAUTH_OUTCOME[keyof typeof REAUTH_OUTCOME]

// Any other code — above all auth/network-request-failed — is a mint we could not complete, not a rejected session.
const REVOKED_SESSION_CODES = new Set(['auth/user-token-expired', 'auth/user-disabled', 'auth/user-not-found', 'auth/invalid-user-token'])

export const recoverFromUnauthorized = async (): Promise<ReauthOutcome> => {
  if (!auth?.currentUser) {
    return REAUTH_OUTCOME.UNAVAILABLE
  }

  try {
    const token = await getFreshToken()
    return token ? REAUTH_OUTCOME.REFRESHED : REAUTH_OUTCOME.UNAVAILABLE
  } catch (error) {
    const code = (error as { code?: string })?.code ?? 'unknown'
    if (REVOKED_SESSION_CODES.has(code)) {
      return REAUTH_OUTCOME.SESSION_OVER
    }

    captureError(error, { reason: 'token refresh unavailable', code })
    return REAUTH_OUTCOME.UNAVAILABLE
  }
}
